import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth, isStaff } from "@/context/AuthContext";

export default function ProtectedRoute({ children, staff = false }) {
  const { user, ready } = useAuth();
  const location = useLocation();
  if (!ready || user === null) {
    return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Laden…</div>;
  }
  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  if (staff && !isStaff(user)) return <Navigate to="/portal" replace />;
  if (!staff && isStaff(user)) return <Navigate to="/admin" replace />;
  return children;
}
